import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(5),
    paddingRight: theme.spacing(15),
  },
  header: {
    fontSize: 26,
    color: theme.palette.primary.dark,
    borderBottom: "solid",
    borderColor: theme.palette.primary.dark,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  label: {
    fontSize: 20,
    color: "#66",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    paddingTop: theme.spacing(2),
  },
  password: {
    color: theme.palette.primary.main,
    fontSize: 15,
    marginRight: theme.spacing(1),
  },
  delete: {
    fontSize: 15,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.error.dark,
    },
  },
  updateDiv: {
    display: "flex",
    justifyContent: "flex-end",
  },
  update: {
    fontSize: 15,
  },
}));

export default useStyles;
